import * as React from "react";
import Paper from "@mui/material/Paper";
import { useNavigate } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useTheme } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {
    Checkbox,
    CircularProgress,
    Dialog,
    DialogContent,
    ThemeProvider,
} from "@mui/material";
import { DetialsProps, InvoiceModal } from "../../../store";// FB  8881 
import {
    PatientData,
    InvoiceData,
    AdminInvoiceData, AdminSetting, GetLogo, PostInvoiceNumber, InvoiceNumber, GetPortalEmployeeN
} from "../../../api";// FB  8881 
//@ts-ignore
import html2pdf from "html2pdf.js";
// Update log
// FB  8099   01/17/2024  SK   Add Support to Patient Portal to Facilitate Patients Seeing their Invoices and Optionally being able to Pay
// FB  8117   02/23/2024  DK  Avoid calling EMR API directly from Portal
// FB  8881   06/14/2024  SK   Show Billing Details in Portal for All Patients in Guest Login Interface
// FB  8816   07/01/2024  SK  Portal print invoice is glitching when exiting too early
// FB  8976   07/08/2024  MS  Fixed Invoice Number issue
// FB  9045   07/24/2024  MS  Fixed Facility Billing Address 
// FB  9779   12/12/2024  SK  Patient payment are not reflected on Portal


//FB 8816
export default function GuestBilling(props: any) {
    const matches = useMediaQuery("(min-width:600px)");
    const navigate = useNavigate();
    const theme = useTheme();
    //const [demo, setdemo] = React.useState("");   FB 9045
    const [check, setChecked] = React.useState(false);
    const [test, setTest] = React.useState(true);
    const [LicenseeName, setLicenseeName] = React.useState("");
    const [adminPayBill, setPayBill] = React.useState("");
    const [billButton, setBillButton] = React.useState(true);
    const [Practice_Address, setPractice_Address] = React.useState("");
    const [Practice_City, setPractice_City] = React.useState("");
    const [Practice_State, setPractice_State] = React.useState("");
    const [Practice_Zip, setPractice_Zip] = React.useState("");
    const [total, setTotal] = React.useState<number>(0);
    const [open, setOpen] = React.useState(false);
    const [showSpinner, setShowSpinner] = React.useState(false);
    const [callipayID, setCallipayID] = React.useState(false);//FB 8816
    const [PatientDetails, setPatientDetails] = React.useState(
        {} as DetialsProps
    );
    var invoiceMessage: any = ""; //FB 9045
    const [InvioceDetails, setInvioceDetails] = React.useState<
        Array<InvoiceProps>
    >([]);
    //FB 9045 BEGIN
    type InvoiceProps = {
        bill_id: any;
        CLAIM_DATE: Date;
        CPTCODE_LABEL: any;
        CPTCODE_DESCRIPTION: any;
        line_item_amount: any;
        allowed_amount: any;
        discount: any;
        insurance_payment: any;
        patient_payment: any;
        copay_payment: any;
        coinsurance_payment: any;
        deductible_payment: any;
        patient_responsible: any;
        icds: any;
        EMPLOYEE_NAME: any;
        EMPLOYEE_PROVIDER_CODE: any;
        FACILITY_NPI: any;
        FACILITY_NAME: any;
        FACILITY_ADDRESS: any;
        FACILITY_ADDRESS2: any;
        FACILITY_CITY_STATE_ZIP: any;
        FACILITY_PHONE: any;
    };
    const [InvoiceAdminData, setInvoiceAdminData] = React.useState<InvoiceAdminProps>();
    type InvoiceAdminProps = {
        InvoiceMessage: any;
        LicenseeName: any;
        Practice_Address: any;
        Practice_City: any;
        Practice_State: any;
        Practice_Zip: any;
        Practice_Phone: any;
        IncludeNPIonInvoice: any;
        Practice_PayTo_NPI: any;
    };
    //FB 9045 END
    const handleClose = () => {
        setOpen(false);
    };
    let GetTotalBalance: number = 0;
    async function getTotal() {
        InvioceDetails.map(
            (x: any) =>
            (GetTotalBalance =
                GetTotalBalance + x.patient_responsible - x.patient_payment)
        );
        if (GetTotalBalance > 0) {
            setChecked(true);
            setTest(false);
        }
        setShowSpinner(false);
        const GetTotalBalanceAsString = GetTotalBalance.toFixed(2).toString();
        sessionStorage.setItem("Total", GetTotalBalanceAsString);
        setTotal(GetTotalBalance);
    }

    setTimeout(function () {
        getTotal();
    }, 5000);

    const [selected, setSelected] = React.useState<string[]>([]);
    const [addedNumbers, setAddedNumbers] = React.useState(0);
    let sum: number = 0;
    const handleClick = (event: React.MouseEvent<unknown>, name: string) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected: string[] = [];
        let numberList: number[] = [];
        function add() {
            for (const num of numberList) {
                sum += num;
                setAddedNumbers(sum);
                const valueAsString = sum.toString();
                sessionStorage.setItem("PayingAmount", valueAsString);
                if ((sum > 0) && (adminPayBill == "true")) {
                    setBillButton(false);
                }
                else {
                    setBillButton(true);
                }
            }
        }

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
            numberList = newSelected.map((str) => parseFloat(str));
            add();
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
            numberList = newSelected.map((str) => parseFloat(str));
            if (newSelected.length == 0) {
                setAddedNumbers(0);
                setBillButton(true);
            }
            else {
                add();
            }
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
            numberList = newSelected.map((str) => parseFloat(str));
            add();
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
            numberList = newSelected.map((str) => parseFloat(str));
            add();
        }

        setSelected(newSelected);
    };

    async function getDetails() {
        var dataEMR = sessionStorage.getItem("PatientInfo");
        if (dataEMR != null) {
            var data = await PatientData(Number(dataEMR));
            //FB 8117
            setPatientDetails({
                ...PatientDetails,
                Patient_ID: data.patient_ID,
                PATIENT_NAME: data.patienT_NAME,
                PATIENT_ADDRESS: data.patienT_ADDRESS,
                PATIENT_CITY_STATE_ZIP: data.patienT_CITY_STATE_ZIP,
            });
        }
    }
    const date = new Date();
    async function getInvoiceDetails() {
        setShowSpinner(true);
        var dataEMR = sessionStorage.getItem("PatientInfo");
        if (dataEMR != null) {
            var data = await InvoiceData(Number(dataEMR));
            setInvioceDetails(data);
        }
    }

    //FB 9045 BEGIN
    //let example: any;
    async function getAdminInvoiceDetails() {
        var example = await AdminInvoiceData();
        setInvoiceAdminData(example);
    }
    //FB 9045 END

    async function adminLicenseeName() {
        var data = await AdminSetting("LicenseeName");
        setLicenseeName(data);
        let adminData = await AdminSetting("Enable_PayBill_Portal");
        setPayBill(adminData);
        //FB 8816 - Begin
        const callipayData = await AdminSetting("CALLIPAY_API_KEY");
        //CLON-2
        const settingValue = callipayData?.[0];
        setCallipayID(!!settingValue?.trim());
        //FB 8816 - End
    }
    async function adminPractice_Address() {
        var data = await AdminSetting("Practice_Address");
        setPractice_Address(data);
    }
    async function adminPractice_City() {
        var data = await AdminSetting("Practice_City");
        setPractice_City(data);
    }
    async function adminPractice_State() {
        var data = await AdminSetting("Practice_State");
        setPractice_State(data);
    }
    async function adminPractice_Zip() {
        var data = await AdminSetting("Practice_Zip");
        setPractice_Zip(data);
    }
    // FB  8881 - Begin
    function getFormattedDate() {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');

        return `${year}/${month}/${day}`;
    }
    async function updateInvoiceID() {
        //FB 8976 BEGIN
        var dataEMR = sessionStorage.getItem("PatientInfo");
        if (dataEMR != null) {
            let id = await InvoiceNumber(Number(dataEMR));
            //let adminData = await AdminSetting("Start_Invoice_Number");
            //const Invoice = id + Number(adminData) + 1;
            setInvoiceID(id);
            const formattedDate = getFormattedDate();
            const dateObject = new Date(formattedDate);
            let data = await GetPortalEmployeeN();
            var dataEMR = sessionStorage.getItem("PatientInfo");
            if (dataEMR != null) {
                const updatedInvoiceStruc = {
                    ...invoiceStruc,
                    INVOICE_PRINT_LOG_N: id,
                    PRINT_DATE: dateObject,
                    PATIENT_N: Number(dataEMR),
                    EMPLOYEE_N: Number(data),
                    INVOICE_NUMBER: id,
                    AMOUNT: total
                };
                PostInvoiceNumber(updatedInvoiceStruc);
            }
        }
        //FB 8976 END
    }
    const [isDisabled, setIsDisabled] = React.useState(false);//FB 8816
    async function handlePrint(i: number) {
        if (i == 1) {
            setIsDisabled(true);//FB 8816
            await updateInvoiceID();
            setOpen(true);
            setTimeout(function () {
                window.print();
            }, 3000);
            //FB 8816 - Begin
            setTimeout(() => {
                setIsDisabled(false);
            }, 4000);
            //FB 8816 - End
        }
        else if (i == 2) {
            setIsDisabled(true);//FB 8816
            setOpen(true);
            //FB 8816 - Begin
            setTimeout(() => {
                setIsDisabled(false);
            }, 2000);
            //FB 8816 - End
        }
        else {
            await updateInvoiceID();
            const content = document.getElementById('pdfDownload');
            if (content) {
                const options = {
                    filename: "" + PatientDetails.PATIENT_NAME + ".pdf",
                };
                html2pdf(content, options);
            }
        }
    }

    const [enableLogo, setEnableLogo] = React.useState(false);
    const [logo, setLogo] = React.useState("");
    const [invoiceID, setInvoiceID] = React.useState(0);
    const [invoiceStruc, setInvoiceStruc] = React.useState({} as InvoiceModal);
    async function GetLogoImage() {

        var img = await GetLogo();
        if (img != null && img != undefined) {
            setLogo(img);
        }
        var data = await AdminSetting("show_invoice_logo");
        if (data == 1) {
            setEnableLogo(true);
        }
    }
    // FB  8881 - End

    React.useEffect(() => {
        GetLogoImage();// FB  8881
        getDetails();
        getInvoiceDetails();
        getAdminInvoiceDetails();
        adminLicenseeName();
        adminPractice_Address();
        adminPractice_City();
        adminPractice_State();
        adminPractice_Zip();
    }, []);
    return (
        <div>
            <div
                style={
                    matches == false ? stylestopmobile.container : stylestart.container
                }
            >
                &nbsp;
                {test === false && (
                    <>
                        <button
                            className="btn"
                            style={{ display: billButton ? 'none' : '', backgroundColor: "#13607C", color: "white" }}
                            onClick={() => navigate("/user/guestPayment")}
                        >
                            Pay Bill
                        </button>
                        &nbsp;
                        <button className="btn" style={Pay.container} onClick={() => handlePrint(1)}>
                            Print Invoice
                        </button>

                        &nbsp;
                        <button className="btn" style={Pay.container} onClick={() => handlePrint(2)}>
                            View Invoice
                        </button>
                        &nbsp;
                        <button className="btn" style={Pay.container} onClick={() => handlePrint(3)}>
                            Download Invoice
                        </button>
                    </>
                )}
                <br />
                {test && (
                    <div
                        style={{
                            height: "100%",
                            backgroundColor: "#F5F5F5",
                            paddingTop: "20px",
                        }}
                    >
                        {" "}
                        No Due Payment
                    </div>
                )}
                {check && (
                    <div>
                        <div className="row" style={{ paddingTop: "20px" }}>
                            <TableContainer component={Paper} style={{ marginTop: "20px" }}>
                                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                    <caption style={{ textAlign: "right", color: "black" }}>
                                        <strong>Total Balance: $ {total.toFixed(2)} </strong><br />
                                        <strong style={{ color: "black" }}>Paying Amount: $ {addedNumbers.toFixed(2)} </strong>
                                    </caption>
                                    <TableHead>
                                        <TableRow>
                                            {/* FB 8816 */}
                                            {callipayID && (
                                                <TableCell align="center">
                                                    <strong>Pay This</strong>
                                                </TableCell>
                                            )}
                                            <TableCell align="center">
                                                <strong>Service Date</strong>
                                            </TableCell>
                                            <TableCell align="center">
                                                <strong>Procedure Code/ Description</strong>&nbsp;
                                            </TableCell>
                                            <TableCell align="center">
                                                <strong>Diagnosis Code(s)</strong> &nbsp;
                                            </TableCell>
                                            <TableCell align="center">
                                                <strong>Our Charge</strong>&nbsp;
                                            </TableCell>
                                            <TableCell align="center">
                                                <strong>Allowed Amount</strong>&nbsp;
                                            </TableCell>
                                            <TableCell align="center">
                                                <strong>Discount</strong>&nbsp;
                                            </TableCell>
                                            <TableCell align="center">
                                                <strong>Insurance Payments</strong>&nbsp;
                                            </TableCell>
                                            <TableCell align="center">
                                                <strong>Patient Responsible</strong>&nbsp;
                                            </TableCell>
                                            <TableCell align="center">
                                                <strong>Patient Payment</strong>&nbsp;
                                            </TableCell>
                                            <TableCell align="center">
                                                <strong>Remaining Patient Balance</strong>&nbsp;
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {InvioceDetails.map((x) => (
                                            <TableRow
                                                key={x.bill_id}
                                                sx={{
                                                    "&:last-child td, &:last-child th": { border: 0 },
                                                }}
                                            >
                                                {/* FB 8816 */}
                                                {callipayID && (
                                                    <TableCell>
                                                        <Checkbox
                                                            color="primary"
                                                            onClick={(event: any) => handleClick(event, (x.patient_responsible - x.patient_payment).toFixed(2))}
                                                        />
                                                    </TableCell>
                                                )}
                                                <TableCell align="center">
                                                    {new Date(x.CLAIM_DATE)
                                                        .toLocaleDateString("en-US", {
                                                            year: "numeric",
                                                            month: "2-digit",
                                                            day: "2-digit",
                                                        })
                                                        .replace(",", "")}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {x.CPTCODE_LABEL}
                                                    &nbsp;
                                                    {x.CPTCODE_DESCRIPTION}
                                                </TableCell>
                                                <TableCell align="center">{x.icds}</TableCell>
                                                <TableCell align="center">
                                                    ${x.line_item_amount.toFixed(2)}
                                                </TableCell>
                                                <TableCell align="center">
                                                    ${x.allowed_amount.toFixed(2)}
                                                </TableCell>
                                                <TableCell align="center">
                                                    (${x.discount.toFixed(2)})
                                                </TableCell>
                                                <TableCell align="center">
                                                    (${x.insurance_payment.toFixed(2)})
                                                </TableCell>
                                                <TableCell align="center">
                                                    ${x.patient_responsible.toFixed(2)}
                                                </TableCell>
                                                <TableCell align="center">
                                                    ${x.patient_payment.toFixed(2)}
                                                </TableCell>
                                                <TableCell align="center">
                                                    $
                                                    {(x.patient_responsible - x.patient_payment).toFixed(
                                                        2
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                        <div className="mt-3 text-center font-weight-bold text-secondary text-sm">
                            Reminder: You are responsible for payment regardless of insurance
                            coverage. If payment has been made, please disregard this notice.
                        </div>
                    </div>
                )}
            </div>
            <div style={{ display: "none" }}>
                <div id='pdfDownload' style={{ fontSize: '0.8em' }}>
                    <div className="container-fluid py-4 px-3 printmargin" >
                        <div className="row">
                            {/* FB 8881 - Begin */}
                            <div>
                                {enableLogo && (
                                    <img
                                        src={logo}
                                        alt="logo"
                                        style={
                                            matches == false
                                                ? { width: '93px', height: '40px', cursor: 'pointer' }
                                                : { maxWidth: '75vw', cursor: 'pointer' }
                                        }
                                    />)}
                            </div>
                            {/* FB 8881 - End */}
                            <div className="col-5">
                                <div className="font-weight-bold FontSize">{LicenseeName}</div>
                                <div>{Practice_Address} </div>
                                <div>
                                    {Practice_City}&nbsp;{Practice_State}&nbsp;{Practice_Zip}
                                </div>
                                <div className="font-weight-bold">RETURN SERVICE REQUESTED</div>
                            </div>

                            <div className="col-6">
                                <div className="border border-dark row">
                                    <div className="w-100 border-bottom border-dark text-center py-3">{/* FB 8881 */}
                                        Patient ID: {PatientDetails.Patient_ID}&nbsp; &nbsp; Invoice Number :{invoiceID}
                                    </div>
                                    <div
                                        className="border-bottom border-right border-dark text-center py-2"
                                        style={{ width: " 40%" }}
                                    >
                                        <div className="font-weight-bold">STATEMENT DATE</div>
                                        <div>
                                            {date
                                                .toLocaleDateString("en-US", {
                                                    year: "numeric",
                                                    month: "2-digit",
                                                    day: "2-digit",
                                                })
                                                .replace(",", "")}
                                        </div>
                                    </div>
                                    <div
                                        className="border-bottom border-right border-dark text-center py-2"
                                        style={{ width: " 40%" }}
                                    >
                                        <div className="font-weight-bold">ACCOUNT NUMBER</div>
                                        <div>{PatientDetails.Patient_ID}</div>
                                    </div>
                                    <div
                                        className="border-bottom border-dark text-center px-3 py-2"
                                        style={{ width: " 20%" }}
                                    >
                                        <div className="font-weight-bold">TOTAL DUE</div>
                                        <div>$ {total} </div>
                                    </div>
                                    <div className="w-50 border-right border-dark px-3 py-2">
                                        <div className="font-weight-bold">PAYMENT DUE BY</div>
                                        <div>UPON RECEIPT</div>
                                    </div>
                                    <div className="w-50  border-dark px-3 py-2">
                                        <div className="font-weight-bold">AMOUNT ENCLOSED</div>
                                        <div>$</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex mt-4">
                            <div className="col-5">
                                <div className="font-weight-bold">ADDRESSEE:</div>
                                <div className="ml-4">{PatientDetails.PATIENT_NAME} </div>
                                <div className="ml-4">{PatientDetails.PATIENT_ADDRESS} </div>
                                <div className="ml-4">
                                    {PatientDetails.PATIENT_CITY_STATE_ZIP}{" "}
                                </div>
                            </div>

                            {/* FB 9045 BEGIN */}
                            {/* FB 9779 */}
                            <div className="col-7">
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: InvoiceAdminData
                                            ? InvioceDetails.length > 0
                                                ? InvoiceAdminData.InvoiceMessage
                                                    ?.replace("100px", "0px")
                                                    ?.replace("@facility_name", InvioceDetails[0]?.FACILITY_NAME || "")
                                                    ?.replace("@facility_address", InvioceDetails[0]?.FACILITY_ADDRESS || "")
                                                    ?.replace("@facility_address2", InvioceDetails[0]?.FACILITY_ADDRESS2 || "")
                                                    ?.replace("@facility_city_state_zip", InvioceDetails[0]?.FACILITY_CITY_STATE_ZIP || "")
                                                    ?.replace("@facility_phone", InvioceDetails[0]?.FACILITY_PHONE || "")
                                                : InvoiceAdminData.InvoiceMessage
                                                    ?.replace("@facility_name", InvoiceAdminData?.LicenseeName || "")
                                                    ?.replace("@facility_address", InvoiceAdminData?.Practice_Address || "")
                                                    ?.replace("@facility_address2", "")
                                                    ?.replace(
                                                        "@facility_city_state_zip",
                                                        `${InvoiceAdminData?.Practice_City || ""}, ${InvoiceAdminData?.Practice_State || ""} ${InvoiceAdminData?.Practice_Zip || ""}`
                                                    )
                                                    ?.replace("@facility_phone", InvoiceAdminData?.Practice_Phone || "")
                                            : ""
                                    }}
                                />
                            </div>
                            {/* FB 9045 END */}
                        </div>

                        <div className="mt-5">
                            <div className="text-right">
                                PLEASE DETACH AND RETURN TOP PORTION WITH YOUR PAYMENT
                            </div>

                            <div className="row mt-3">
                                <div className="col-3">
                                    <div className="font-weight-bold">Patient:</div>
                                    <div className="font-weight-bold">Rendering Provider:</div>
                                    <div className="font-weight-bold">Location</div>
                                </div>
                                <div className="col-3">
                                    <div>{PatientDetails.PATIENT_NAME} </div>
                                    <div></div>
                                    <div></div>
                                </div>
                                <div className="col-3">
                                    <div className="font-weight-bold">Patient Number:</div>
                                    <div className="font-weight-bold">Due Date:</div>
                                    <div className="font-weight-bold">Patient Balance:</div>
                                </div>
                                <div className="col-3">
                                    <div>{PatientDetails.Patient_ID} </div>
                                    <div>Upon Receipt</div>
                                    <div>$ {total} </div>
                                </div>
                            </div>

                            <table style={{ fontSize: '0.8em' }}>
                                <thead>
                                    <tr>
                                        <th>Service Date</th>
                                        <th style={{ padding: '5px' }}>Procedure Code/ Description</th>
                                        <th style={{ padding: '5px' }}>Diagnosis Code(s)</th>
                                        <th style={{ padding: '5px' }}>Our Charge</th>
                                        <th style={{ padding: '5px' }}>Allowed Amount</th>
                                        <th style={{ padding: '5px' }}>Discount</th>
                                        <th style={{ padding: '5px' }}>Insurance Payments</th>
                                        <th style={{ padding: '5px' }}>Patient Responsible</th>
                                        <th style={{ padding: '3px' }}>Patient Payment</th>
                                        <th>Remaining Patient Balance</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {InvioceDetails.map((x) => (
                                        <tr>
                                            <td>
                                                {new Date(x.CLAIM_DATE)
                                                    .toLocaleDateString("en-US", {
                                                        year: "numeric",
                                                        month: "2-digit",
                                                        day: "2-digit",
                                                    })
                                                    .replace(",", "")}{" "}
                                            </td>
                                            <td style={{ padding: '5px' }}>
                                                {x.CPTCODE_LABEL}
                                                &nbsp;
                                                {x.CPTCODE_DESCRIPTION}
                                            </td>
                                            <td style={{ padding: '5px' }}>{x.icds} </td>
                                            <td style={{ padding: '5px' }}>
                                                ${x.line_item_amount.toFixed(2)}
                                            </td>
                                            <td style={{ padding: '5px' }}>
                                                ${x.allowed_amount.toFixed(2)}
                                            </td>
                                            <td style={{ padding: '5px' }}>
                                                (${x.discount.toFixed(2)})
                                            </td>
                                            <td style={{ padding: '5px' }}>
                                                (${x.insurance_payment.toFixed(2)})
                                            </td>
                                            <td style={{ padding: '5px' }}>
                                                ${x.patient_responsible.toFixed(2)}
                                            </td>
                                            <td style={{ padding: '5px' }}>
                                                ${x.patient_payment.toFixed(2)}
                                            </td>
                                            <td>
                                                $
                                                {(x.patient_responsible - x.patient_payment).toFixed(2)}
                                            </td>
                                        </tr>
                                    ))}

                                    <tr>
                                        <td
                                            colSpan={10}
                                            align="right"
                                            className="py-4 px-4 font-weight-bold text-right"
                                        >
                                            <b> Total Balance :$ {total.toFixed(2)} </b>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="mt-3 text-center font-weight-bold text-secondary text-sm">
                            Reminder: You are responsible for payment regardless of insurance
                            coverage. If payment has been made, please disregard this notice.
                        </div>
                    </div>
                </div></div>

            <ThemeProvider theme={theme}>
                <Dialog open={showSpinner} fullWidth maxWidth={"xs"}>
                    <DialogContent
                        style={{
                            display: "flex",
                            alignContent: "center",
                            justifyContent: "center",
                        }}
                    >
                        <CircularProgress style={{ color: "#083A4D" }} />
                    </DialogContent>
                </Dialog>
            </ThemeProvider>
            <Dialog
                open={open}
                onClose={handleClose}
                style={{ width: "95%" }}
                fullScreen
            >
                {open && (
                    <div className="container-fluid py-4 px-3 printmargin" >
                        <div className="HideIcon">
                            {/* FB 8816 */}
                            <IconButton onClick={handleClose} aria-label="close" disabled={isDisabled}>
                                <CloseIcon />
                            </IconButton>
                        </div>

                        <div className="row">
                            {/* FB 8881 - Begin */}
                            <div>
                                {enableLogo && (
                                    <img
                                        src={logo}
                                        alt="logo"
                                        style={
                                            matches == false
                                                ? { width: '93px', height: '40px', cursor: 'pointer' }
                                                : { maxWidth: '75vw', cursor: 'pointer' }
                                        }
                                    />)}
                            </div>
                            {/* FB 8881 - End */}
                            <div className="col-5">
                                <div className="font-weight-bold FontSize">{LicenseeName}</div>
                                <div>{Practice_Address} </div>
                                <div>
                                    {Practice_City}&nbsp;{Practice_State}&nbsp;{Practice_Zip}
                                </div>
                                <div className="font-weight-bold">RETURN SERVICE REQUESTED</div>
                            </div>

                            <div className="col-6">
                                <div className="border border-dark row">
                                    <div className="w-100 border-bottom border-dark text-center py-3">{/* FB 8881 */}
                                        Patient ID: {PatientDetails.Patient_ID}&nbsp; &nbsp; Invoice Number :{invoiceID}
                                    </div>
                                    <div
                                        className="border-bottom border-right border-dark text-center py-2"
                                        style={{ width: " 40%" }}
                                    >
                                        <div className="font-weight-bold">STATEMENT DATE</div>
                                        <div>
                                            {date
                                                .toLocaleDateString("en-US", {
                                                    year: "numeric",
                                                    month: "2-digit",
                                                    day: "2-digit",
                                                })
                                                .replace(",", "")}
                                        </div>
                                    </div>
                                    <div
                                        className="border-bottom border-right border-dark text-center py-2"
                                        style={{ width: " 40%" }}
                                    >
                                        <div className="font-weight-bold">ACCOUNT NUMBER</div>
                                        <div>{PatientDetails.Patient_ID}</div>
                                    </div>
                                    <div
                                        className="border-bottom border-dark text-center px-3 py-2"
                                        style={{ width: " 20%" }}
                                    >
                                        <div className="font-weight-bold">TOTAL DUE</div>
                                        <div>$ {total} </div>
                                    </div>
                                    <div className="w-50 border-right border-dark px-3 py-2">
                                        <div className="font-weight-bold">PAYMENT DUE BY</div>
                                        <div>UPON RECEIPT</div>
                                    </div>
                                    <div className="w-50  border-dark px-3 py-2">
                                        <div className="font-weight-bold">AMOUNT ENCLOSED</div>
                                        <div>$</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex mt-4">
                            <div className="col-5">
                                <div className="font-weight-bold">ADDRESSEE:</div>
                                <div className="ml-4">{PatientDetails.PATIENT_NAME} </div>
                                <div className="ml-4">{PatientDetails.PATIENT_ADDRESS} </div>
                                <div className="ml-4">
                                    {PatientDetails.PATIENT_CITY_STATE_ZIP}{" "}
                                </div>
                            </div>

                            {/* FB 9045 BEGIN */}
                            {/* FB 9779 */}
                            <div className="col-7">
                                <div>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: InvoiceAdminData
                                                ? InvioceDetails.length > 0
                                                    ? InvoiceAdminData.InvoiceMessage
                                                        ?.replace("100px", "0px")
                                                        ?.replace("@facility_name", InvioceDetails[0]?.FACILITY_NAME || "")
                                                        ?.replace("@facility_address", InvioceDetails[0]?.FACILITY_ADDRESS || "")
                                                        ?.replace("@facility_address2", InvioceDetails[0]?.FACILITY_ADDRESS2 || "")
                                                        ?.replace("@facility_city_state_zip", InvioceDetails[0]?.FACILITY_CITY_STATE_ZIP || "")
                                                        ?.replace("@facility_phone", InvioceDetails[0]?.FACILITY_PHONE || "")
                                                    : InvoiceAdminData.InvoiceMessage
                                                        ?.replace("@facility_name", InvoiceAdminData?.LicenseeName || "")
                                                        ?.replace("@facility_address", InvoiceAdminData?.Practice_Address || "")
                                                        ?.replace("@facility_address2", "")
                                                        ?.replace(
                                                            "@facility_city_state_zip",
                                                            `${InvoiceAdminData?.Practice_City || ""}, ${InvoiceAdminData?.Practice_State || ""} ${InvoiceAdminData?.Practice_Zip || ""}`
                                                        )
                                                        ?.replace("@facility_phone", InvoiceAdminData?.Practice_Phone || "")
                                                : ""
                                        }}
                                    />

                                </div>
                            </div>
                            {/* FB 9045 END */}
                        </div>

                        <div className="mt-5">
                            <div className="text-right">
                                PLEASE DETACH AND RETURN TOP PORTION WITH YOUR PAYMENT
                            </div>

                            <div className="row mt-3">
                                <div className="col-3">
                                    <div className="font-weight-bold">Patient:</div>
                                    <div className="font-weight-bold">Rendering Provider:</div>
                                    <div className="font-weight-bold">Location</div>
                                </div>
                                <div className="col-3">
                                    <div>{PatientDetails.PATIENT_NAME} </div>
                                    <div></div>
                                    <div></div>
                                </div>
                                <div className="col-3">
                                    <div className="font-weight-bold">Patient Number:</div>
                                    <div className="font-weight-bold">Due Date:</div>
                                    <div className="font-weight-bold">Patient Balance:</div>
                                </div>
                                <div className="col-3">
                                    <div>{PatientDetails.Patient_ID} </div>
                                    <div>Upon Receipt</div>
                                    <div>$ {total} </div>
                                </div>
                            </div>
                            <table className="mt-2 ">
                                <thead>
                                    <tr>
                                        <th >Service Date</th>
                                        <th className="pt-4 px-3">Procedure Code/ Description</th>
                                        <th className="pt-4 px-3">Diagnosis Code(s)</th>
                                        <th className="pt-4 px-3">Our Charge</th>
                                        <th className="pt-4 px-3">Allowed Amount</th>
                                        <th className="pt-4 px-3">Discount</th>
                                        <th className="pt-4 px-3">Insurance Payments</th>
                                        <th className="pt-4 px-3">Patient Responsible</th>
                                        <th className="pt-4 px-3">Patient Payment</th>
                                        <th>Remaining Patient Balance</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {InvioceDetails.map((x) => (
                                        <tr>
                                            <td className="pt-4 px-3">
                                                {new Date(x.CLAIM_DATE)
                                                    .toLocaleDateString("en-US", {
                                                        year: "numeric",
                                                        month: "2-digit",
                                                        day: "2-digit",
                                                    })
                                                    .replace(",", "")}{" "}
                                            </td>
                                            <td className="pt-4 px-3">
                                                {x.CPTCODE_LABEL}
                                                &nbsp;
                                                {x.CPTCODE_DESCRIPTION}
                                            </td>
                                            <td className="pt-4 px-3">{x.icds} </td>
                                            <td className="pt-4 px-3 text-right">
                                                ${x.line_item_amount.toFixed(2)}
                                            </td>
                                            <td className="pt-4 px-3 text-right">
                                                ${x.allowed_amount.toFixed(2)}
                                            </td>
                                            <td className="pt-4 px-3 text-right">
                                                (${x.discount.toFixed(2)})
                                            </td>
                                            <td className="pt-4 px-3 text-right">
                                                (${x.insurance_payment.toFixed(2)})
                                            </td>
                                            <td className="pt-4 px-3 text-right">
                                                ${x.patient_responsible.toFixed(2)}
                                            </td>
                                            <td className="pt-4 px-3 text-right">
                                                ${x.patient_payment.toFixed(2)}
                                            </td>
                                            <td>
                                                $
                                                {(x.patient_responsible - x.patient_payment).toFixed(2)}
                                            </td>
                                        </tr>
                                    ))}

                                    <tr>
                                        <td
                                            colSpan={10}
                                            align="right"
                                            className="py-4 px-4 font-weight-bold text-right"
                                        >
                                            <b> Total Balance :$ {total.toFixed(2)} </b>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="mt-3 text-center font-weight-bold text-secondary text-sm">
                            Reminder: You are responsible for payment regardless of insurance
                            coverage. If payment has been made, please disregard this notice.
                        </div>
                    </div>
                )}
            </Dialog>
        </div>
    );
}

const stylestart = {
    container: {
        border: "5px grey",
        paddingLeft: "80px",
        marginBottom: "20px",
        backgroundColor: "#F5F5F5",
        paddingTop: "20px",
        paddingRight: "80px",
    },
};
const stylestopmobile = {
    container: {
        padding: "0px 15px 32px 16px",
        backgroundColor: "#F5F5F5",
    },
};

const card = {
    container: {
        border: "5px white",
        minHeight: "150px",
    },
};
const Pay = {
    container: {
        backgroundColor: "#13607C",
        color: "white",
        cursor: "pointer"
    },
};

const View = {
    container: {
        color: "#13607C",
        backgroundColor: "#F5F5F7",
        marginRight: "165px",
        borderColor: "#13607C",
        fontWeight: 700,
    },
};
